import React from "react";
import { ScrollToTop } from "@components";
import DefaultFilterableVoucherList from "./DefaultFilterableVoucherList";
import { usePageTitle } from "@hooks";

export default function VouchersPage() {
	usePageTitle("Belege");
	return (
		<>
			<ScrollToTop />
			<DefaultFilterableVoucherList />
		</>
	);
}
